export var GA_EXPERIMENT_SLOTS;
(function (GA_EXPERIMENT_SLOTS) {
    GA_EXPERIMENT_SLOTS["ALPHA"] = "alpha";
    GA_EXPERIMENT_SLOTS["BETA"] = "beta";
    GA_EXPERIMENT_SLOTS["GAMMA"] = "gamma";
    GA_EXPERIMENT_SLOTS["DELTA"] = "delta";
    GA_EXPERIMENT_SLOTS["EPSILON"] = "epsilon";
})(GA_EXPERIMENT_SLOTS || (GA_EXPERIMENT_SLOTS = {}));
